/**
 * Days represents the week days with numbers
 */

export enum Days{
    Sunday = 6,
    Monday = 0,
    Tuesday = 1,
    Wednesday = 2,
    Thursday = 3,
    Friday = 4,
    Saturday = 5,
}
